export const MISSING_COMPANY_LOGO = 'assets/dashboard/missing-company.png';
export const TABLET_BREAKPOINT = 1300;
export const MOBILE_BREAKPOINT = 1000;
